module.exports = __webpack_public_path__ + "img/halloween-window-24.c3469ba4.svg";